import { CheckoutState } from '../../state';
import { isEventbriteTLDInDevOrQAEnv } from '../../utils/browser';
import { isEventbriteTLD } from '../app';
import {
    getHasPromoCode,
    getIsFreeEvent,
    getIsReservedSeating,
    isDonation,
} from '../event';
import { getHasAddonsTicketsAvailable } from '../tickets/getHasAddonsTicketsAvailable';
import {
    getHasRequiredQuestions,
    isApplePayAvailableAsExpressPaymentMethod,
} from './pureSelectors';

export const isApplePayElegible = (state: CheckoutState) =>
    isApplePayAvailableAsExpressPaymentMethod(state) &&
    !getIsFreeEvent(state) &&
    !getHasRequiredQuestions(state) &&
    !getHasPromoCode(state) &&
    !getIsReservedSeating(state) &&
    !isDonation(state) &&
    !getHasAddonsTicketsAvailable(state) &&
    (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv());
